'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.props = exports.EVENT_BEFORE_TAB_CLOSED = exports.EVENT_TAB_CLOSE = exports.EVENT_BEFORE_TAB_DEACTIVATED = exports.EVENT_TAB_ACTIVATE = exports.EVENT_TAB_DATA = exports.EVENT_TAB_STATUS = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _Event = require('../Core/Event');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @readonly
 * @type {string}
 */
var EVENT_TAB_STATUS = exports.EVENT_TAB_STATUS = 'context.tab_status';

/**
 * @readonly
 * @type {string}
 */
/**
 * This module exports events available when the application is hosted by a UI Tab component
 *
 * @module Context/eventsTicket
 */

var EVENT_TAB_DATA = exports.EVENT_TAB_DATA = 'context.tab_data';

/**
 * @readonly
 * @type {string}
 */
var EVENT_TAB_ACTIVATE = exports.EVENT_TAB_ACTIVATE = 'context.tab_activate';

/**
 * This is not used at the moment
 *
 * @ignore
 * @readonly
 * @type {string}
 */
var EVENT_BEFORE_TAB_DEACTIVATED = exports.EVENT_BEFORE_TAB_DEACTIVATED = 'context.before_tab_deactivated';

/**
 * @readonly
 * @type {string}
 */
var EVENT_TAB_CLOSE = exports.EVENT_TAB_CLOSE = 'context.tab_close';

/**
 * This is not used at the moment
 *
 * @ignore
 * @readonly
 * @type {string}
 */
var EVENT_BEFORE_TAB_CLOSED = exports.EVENT_BEFORE_TAB_CLOSED = 'context.before_tab_closed';

var events = {

  EVENT_TAB_DATA: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },

  EVENT_TAB_ACTIVATE: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },

  EVENT_TAB_CLOSE: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE }
};

/**
 * @enum
 * @readonly
 * @type {{EVENT_ME_GET: {channelType: string, invocationType: string}, EVENT_TAB_DATA: {channelType: string, invocationType: string}, EVENT_TAB_ACTIVATE: {channelType: string, invocationType: string}, EVENT_TAB_CLOSE: {channelType: string, invocationType: string}}}
 */
var props = exports.props = events;

/**
 * @readonly
 * @type {Array<string>}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 *
 * @param {string} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Context/eventsTab.js
// module id = 104
// module chunks = 0